import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const Frame = ({ src, alt, caption, className = "", testId, delay = 0 }) => (
  <Reveal delay={delay} className={className}>
    <figure data-testid={testId} className="group relative h-full min-h-[260px] overflow-hidden rounded-[28px] bg-[#EBD7C7]">
      <motion.img
        src={src}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1D2F]/75 via-[#0F1D2F]/5 to-transparent" />
      {caption && (
        <figcaption className="absolute left-5 right-5 bottom-5 text-white font-serif text-xl sm:text-2xl leading-tight">
          {caption}
        </figcaption>
      )}
    </figure>
  </Reveal>
);

export const Impact = () => (
  <section id="impact" data-testid="impact-section" className="relative bg-[#FAF7F2] py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-8 mb-14 lg:mb-20 items-end">
        <div className="lg:col-span-6">
          <Eyebrow testId="impact-eyebrow">Our Impact</Eyebrow>
          <Reveal>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#0F1D2F] mt-6 leading-[0.95] tracking-tight">
              Snapshots of <em className="text-fire">real change.</em>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8">
          <p data-testid="impact-intro" className="text-base sm:text-lg text-[#2B3A4A] leading-relaxed">
            From enabling access to education and healthcare to advocating for rights and inclusion, these snapshots highlight the tangible differences Wings of Fire Foundation has made across Telangana.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-5 lg:gap-6 md:auto-rows-[220px] lg:auto-rows-[200px]">
        <Frame testId="impact-card-inclusion" src="/images/p13.jpg" alt="Award ceremony" caption="Celebrating inclusion & community" className="md:col-span-6 lg:col-span-7 md:row-span-2" />
        <Frame testId="impact-card-community" src="/images/p6.jpg" alt="Relief distribution" caption="Deeply Rooted in Community" className="md:col-span-3 lg:col-span-5 md:row-span-2" delay={0.1} />
        <Frame testId="impact-photo-classroom" src="/images/p8.jpg" alt="Awareness session in a classroom" className="md:col-span-3 lg:col-span-4 md:row-span-2" />
        <Reveal delay={0.1} className="md:col-span-3 lg:col-span-4 md:row-span-2">
          <div data-testid="impact-card-families" className="h-full min-h-[260px] rounded-[28px] bg-[#4B6962] p-8 flex flex-col justify-between text-white relative overflow-hidden">
            <img src="/images/wings.png" alt="" className="absolute -right-10 -bottom-6 w-56 opacity-20" />
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#F2D3B3]">Every stage</p>
            <p className="font-serif text-3xl sm:text-4xl leading-tight relative">
              We work with children and families through all stages of the development phase.
            </p>
          </div>
        </Reveal>
        <Frame testId="impact-photo-college" src="/images/p7.jpg" alt="Students at a college programme" className="md:col-span-6 lg:col-span-4 md:row-span-2" delay={0.2} />
      </div>
    </div>
  </section>
);
